import { FC } from 'react'

import styled from 'styled-components'

import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'
import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'

import {
  GenreWithoutCurators,
  PredefinedGenres,
} from '../AdsGenresModalContent/helpers'

type Props = {
  genres?: PredefinedGenres[]
  selectedGenres?: GenreWithoutCurators[]
  onClickGenre: (genre: GenreWithoutCurators) => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  margin: 0;
`
const List = styled.ul`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`

export const AdPredefinedGenresList: FC<Props> = ({
  genres,
  selectedGenres,
  onClickGenre,
}) => {
  if (!genres || genres.length === 0) {
    return null
  }

  return (
    <>
      {genres.map((item) => {
        if (!item.genres || item.genres.length === 0) {
          return null
        }
        return (
          <Container key={item.subTitle}>
            <Title>{item.subTitle}</Title>
            <List>
              {item.genres.map((genre) => (
                <LabelForGenreOrLanguage
                  key={genre.id}
                  title={capitalizeFirstLetter(genre.genreName)}
                  hasCross={selectedGenres?.some(
                    (selectedGenre) => selectedGenre.id === genre.id,
                  )}
                  onClick={() => onClickGenre(genre)}
                />
              ))}
            </List>
          </Container>
        )
      })}
    </>
  )
}
